//////////////////////////////////////////////////

module.exports = {

    item: {
        settings       : { size: 'sm', },
        first_name     : { label: 'Nome' },
        last_name      : { label: 'Cognome' },
        codice_fiscale : { label: 'Codice Fiscale' },
        email          : { label: 'Email' },
        title          : { label: 'Titolo' },
        note           : { label: 'Note' },
        file           : { label: 'Documento', skip: 'edit' },
        code           : { skip: true, },
        created        : { skip: true, },
        created_by     : { skip: true, },
        company_id     : { skip: true, },
        config         : { skip: true, },
        id             : { skip: true, },
    },

    search_item: {
        settings        : { size: 'sm', },
        created__gte    : { label: 'Da', },
        created__lte    : { label: 'A', },
        first_name      : { label: 'Nome' },
        last_name       : { label: 'Cognome' },
        title           : { label: 'Titolo' },
        code            : { label: 'Codice' },
        'config.status' : { label: 'Stato' },
    },

};

